export class SortenVerteilungService {
    validate(sorten, printRun) {
        const url = `/api/${window.languagepath}/prj/products/variants`;

        const variants = sorten.map((sorte) => ({
            title: sorte.variantIdentifier ?? '',
            number: sorte.num ?? 0,
            file_name: sorte.fileName ?? '',
        }));

        const body = {
            data: {
                print_run: printRun, variants
            }
        }

        return fetch(url, {
            method: "POST", body: JSON.stringify(body)
        }).then((response) => response.json())
    }
}